import { useQuery } from 'react-query';
import PESService from 'App/services/PESService';

function useFetchMobileUrlQuery(patientId, activityId) {
    return useQuery(
        ['patient', patientId, 'activity', activityId, 'mobileUrl'],
        () => PESService.getMobileUrl(patientId, activityId),
        {
            retry: false,
            refetchInterval: false,
            refetchOnWindowFocus: false,
        }
    );
}

export default useFetchMobileUrlQuery;
